/**
 * @param {string} fallbackPrefix
 * @returns {string}
 */
function createCursoRowClientId(fallbackPrefix) {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `${fallbackPrefix}${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
  );
}

/**
 * @param {string} fallbackPrefix
 * @returns {{ id: string; cursoId: string }}
 */
export function createEmptyCursoRow(fallbackPrefix) {
  return { id: createCursoRowClientId(fallbackPrefix), cursoId: "" };
}

/**
 * @returns {{ id: string; cursoId: string }}
 */
export function newCursoRow() {
  return createEmptyCursoRow("curso-row-");
}

/**
 * @returns {{ id: string; cursoId: string }}
 */
export function newGestorCursoRow() {
  return createEmptyCursoRow("gestor-curso-row-");
}
